import React, { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import "./ReviewsTestimonialsSection.css";

const EMBED_SOCIAL_SCRIPT = "https://embedsocial.com/js/iframe.js";

const GOOGLE_REVIEWS_IFRAME_SRC =
  "https://embedsocial.com/api/pro_hashtag/72bb842a7bf04b3ad5e4346ea73e3da8e00b7c2f";

export default function ReviewsTestimonialsSection() {
  useEffect(() => {
    // Prevent duplicate script injection
    if (!document.querySelector(`script[src="${EMBED_SOCIAL_SCRIPT}"]`)) {
      const script = document.createElement("script");
      script.src = EMBED_SOCIAL_SCRIPT;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <Box className="reviews-testimonials-section">
      <div className="container">
        <Typography variant="h4" className="section-title">
          What Our Clients Say
        </Typography>

        <div className="reviews-testimonials-content">
          <div className="reviews-section">
            <Typography variant="h5" className="sub-title">
              Google Reviews
            </Typography>

            <div className="reviews-carousel-wrapper">
              <iframe
                src={GOOGLE_REVIEWS_IFRAME_SRC}
                title="Google Reviews"
                loading="lazy"
                scrolling="no"
                referrerPolicy="no-referrer"
                sandbox="allow-scripts allow-same-origin allow-popups"
              />
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
}
